module.exports = __webpack_public_path__ + "img/103.fe66971f.jpg";